import { Box, Text } from "@chakra-ui/react";
import { useGetFiatAccountQuery } from "apis";
import { AddFiatAccount, AddMobileMoney, InputLabel, Select } from "components";
import { useMemo } from "react";

interface IProps {
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  isDisabled: boolean;
  fiatType: string;
}
const GetFiatAccount = ({ onChange, isDisabled, fiatType }: IProps) => {
  const { data, isSuccess } = useGetFiatAccountQuery({});

  const checkDataLength = useMemo(() => {
    return isSuccess && Object.values(data!).length === 0;
  }, [data, isSuccess]);

  const mergeData = useMemo(() => {
    return fiatType?.toLowerCase() === "ngn" ? data?.BankAccount! : data?.MobileMoney!;
  }, [data, fiatType]);

  console.log(mergeData, "THE MERGED DATA");

  const defaultValue = useMemo(() => {
    if (isDisabled && !checkDataLength) {
      const acctName = (mergeData && mergeData[0]?.accountName) ?? "";
      const bankName = (mergeData && mergeData[0]?.institutionName) ?? "";
      return `${acctName} ${bankName}`;
    }
  }, [isDisabled, checkDataLength, mergeData]);

  return (
    <>
      <Box mb="16px" display={checkDataLength ? "none" : "block"}>
        <InputLabel htmlFor="fiatAccountId">Choose Fiat Account</InputLabel>

        <Select id="fiatAccountId" name="fiatAccountId" onChange={onChange} isDisabled={isDisabled || checkDataLength}>
          {isDisabled ? <option value="">{defaultValue}</option> : <option value="">Select Account</option>}

          {mergeData && (
            <>
              {mergeData?.map(({ accountName, fiatAccountId, institutionName }) => {
                return (
                  <option key={fiatAccountId} value={fiatAccountId}>
                    {accountName} {fiatType === "ngn" ? institutionName : institutionName.toUpperCase()}
                  </option>
                );
              })}
            </>
          )}

          {isSuccess && !isDisabled && <option value="new-account">Add New Account</option>}
        </Select>
      </Box>

      {/* <AddFiatAccount /> */}
      {checkDataLength && (
        <Box>
          <Text fontWeight="600">
            Provide the details for your{" "}
            <Text as="span" textTransform="uppercase">
              {fiatType?.toUpperCase() ?? "NGN"}
            </Text>{" "}
            account
          </Text>

          {fiatType.toLowerCase() === "ngn" ? <AddFiatAccount fiatType="ngn" /> : <AddMobileMoney fiatType={fiatType!} />}
        </Box>
      )}
    </>
  );
};

export default GetFiatAccount;
